export default {
  'Difficulty level': 'Svårighetsgrad',
  'Your bet': 'Satsa',
  'Start game': 'Spela',
  'Take prize': 'Ta',
  'Try again': 'Försök igen',
  Bet: 'Satsa',
  Profit: 'Vinst',
};
